import { Icon, IconsEnum } from 'components/Icons';
import { RichText } from 'components/richText';
import styles from './RegistrationUncompleted.module.scss';
import { useEffect, useMemo } from 'react';
import { PathName, getRouteByKey } from 'utility/routes';
import { useRouter } from 'next/router';
import { gtag } from 'utility/functions';

export type RegistrationUnCompletedLabel = {
  title: string;
  description: string;
  buttonLabel: string;
};

export type RegistrationUncompletedProps = {
  labels: RegistrationUnCompletedLabel;
  descriptionError?: string;
  onTryAgainClicked: () => void;
  hideRetryBtn?: boolean;
};
export const RegistrationUncompleted = ({
  labels,
  descriptionError,
  onTryAgainClicked,
  hideRetryBtn,
}: RegistrationUncompletedProps) => {
  const registrationUrl = useMemo(() => getRouteByKey(PathName.registrationUrl), []);
  const router = useRouter();

  useEffect(() => {
    if (router.asPath.includes(registrationUrl)) {
      gtag(
        {
          section: 'RegistrationStepUncompleted',
          detail: 'RegistrationStepUncompleted',
          event: 'RegistrationStepUncompleted',
        },
        true
      );
    }
  }, [registrationUrl, router.asPath]);

  return (
    <div className={styles.container}>
      <Icon iconId={IconsEnum.CANCEL} color="var(--color-warning)" className={styles.iconError} />
      <RichText tag="h2" containerClassName={styles.title}>
        {labels.title}
      </RichText>

      <RichText tag="p" containerClassName={styles.description}>
        {descriptionError ?? labels.description}
      </RichText>
      {!hideRetryBtn && (
        <button className={styles.button} type="button" onClick={onTryAgainClicked}>
          {labels.buttonLabel}
        </button>
      )}
    </div>
  );
};
